<template>
    <loader :loading="loading || loadingCards || loadingBanks">
        <div v-if="customerCards.length > 0">
            <div class="row mb-3" v-for="(card, index) in customerCards" :key="index">
                <div class="col d-flex justify-content-center">
                    <card-item
                        :card="card"
                        :is-default-payment="isDefault('card', card.id)"
                        :is-valid-processor="isValidProcessor(card.provider)"
                        @make-default="makeDefault('card', card.id)"
                        @delete="deleteCard(card.id)"
                        @reverify="reverifyCard(card)"
                    ></card-item>
                </div>
            </div>
        </div>

        <div v-if="customerBanks.length > 0">
            <div class="row mb-2" v-for="(bank, index) in customerBanks" :key="index">
                <div class="col d-flex justify-content-center">
                    <bank-item
                        :bank="bank"
                        :is-default-payment="isDefault('bank', bank.id)"
                        @make-default="onBankMakeDefault(bank)"
                        @delete="deleteBank(bank.id)"
                    ></bank-item>
                </div>
            </div>
        </div>

        <div class="row my-3">
            <div class="col" @click="addNewCard()">
                <div class="btn btn-outline-primary btn-block btn-lg px-5 d-flex justify-content-between align-items-center">
                    <span class="font-14">{{ $t('Add New Credit Card') }}</span>
                    <icon class="ml-auto" icon="long-arrow-right" size="xl"></icon>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col" @click="addNewBank()">
                <div class="btn btn-outline-primary btn-block btn-lg px-5 d-flex justify-content-between align-items-center">
                    <span class="font-14">{{ $t('Add New ACH Account') }}</span>
                    <icon class="ml-auto" icon="long-arrow-right" size="xl"></icon>
                </div>
            </div>
        </div>

        <b-modal
            id="lease-picker-modal"
            v-model="showLeasePicker"
            :title="$t('Select Lease for Default Payment')"
            @hide="showLeasePicker = false"
            hide-footer
            hide-header
            centered
        >
            <div>
                <lease-carousel v-model="selectedLease" @leaseselected=""/>
                <div class="mt-3 justify-content-between d-flex">
                    <fn-type-checkbox-input
                        statement="I understand"
                        :checked-value="true"
                        :unchecked-value="false"
                        v-model="iUnderstand"
                        switch>
                    </fn-type-checkbox-input>   
                    <b-button variant="primary" :disabled="!selectedLease || !iUnderstand" @click="confirmBankDefault">
                        {{ $t('Confirm') }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </loader>
</template>

<script>
import customerDetails from "../../../dashboard/mixins/customerDetails";
import CardItem from "../../components/CardItem";
import BankItem from "../../components/BankItem";
import LeaseCarousel from "../../components/LeaseCarousel";
import {ADD_CARD_SCREEN, ADD_BANK_SCREEN} from "@/features/profile/screens";
import {fnResponseToNotification} from "@fndry-vue/fn-notify";
import {
    FnTypeCheckboxInput
} from "@fndry-vue/fn-types";

export default {
    name: "PaymentMethodsTab",
    mixins: [customerDetails],
    components: {
        CardItem,
        BankItem,
        LeaseCarousel, 
        FnTypeCheckboxInput
    },
    data() {
        return {
            loading : false,
            showLeasePicker: false,
            selectedLease: null,
            pendingBank: null,
            iUnderstand: false,
        }
    },
    methods: {
        refresh() {
            this.getCustomerCards();
            this.getCustomerBanks();
        },
        addNewCard() {
            this.$router.push({
                name: ADD_CARD_SCREEN
            })
        },
        addNewBank() {
            this.$router.push({
                name: ADD_BANK_SCREEN
            })
        },
        isDefault(type, id) {
            return this.defaultPayment.payment_type === type && this.defaultPayment.id === id;
        },
        isValidProcessor(provider) {
            return provider == "payliance" || provider == "fluidpay";
        },
        onBankMakeDefault(bank) {
            this.pendingBank = bank;
            this.selectedLease = null;
            this.showLeasePicker = true;
        },
        confirmBankDefault() {
            if (this.pendingBank && this.selectedLease) {
                this.makeDefault('bank', this.pendingBank.id);
                this.showLeasePicker = false;
                this.pendingBank = null;
                this.selectedLease = null;
            }
        },
        makeDefault(type, id) {
            this.loading = true;
            var data = {
                type: type,
                id: id
            };

            if (this.selectedLease) {
                data = { 
                    ...data, 
                    loan_number: this.selectedLease.loan_number,
                    routing_number: this.pendingBank.routing,
                    account: this.pendingBank.account
                };
            }

            this.$fnApi.call('/api/v1/mobile/customers/payments/default', 'POST', data).then(response => {
                if(response.status) {
                    this.refresh();
                } else {
                    this.$fnNotify(fnResponseToNotification(response))
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        deleteCard(id) {
            if(id != null) {
                this.$fnApi.call(`/api/v1/mobile/cards/${id}/delete`, 'POST').then(response => {
                    if(response.status) {
                        this.refresh();
                    } else {
                        this.$fnNotify(fnResponseToNotification(response))
                    }
                })
            }
        },
        reverifyCard(card) {
            this.$router.push({
                name: ADD_CARD_SCREEN,
                params: {
                    old_card: card,
                }
            });
        },
        deleteBank(id) {
            if(id != null) {
                this.$fnApi.call(`/api/v1/mobile/banks/${id}/delete`, 'POST').then(response => {
                    if(response.status) {
                        this.refresh();
                    } else {
                        this.$fnNotify(fnResponseToNotification(response))
                    }
                })
            }
        }
    }
}
</script>
